import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, Header, Icon, Image } from 'semantic-ui-react';
import { ApplicationState, routes, strings } from '../..';
import * as Core from '../../core';
import AzionePrincipale from './AzionePrincipale';
import { mediaStyles, MediaContextProvider, Media, constants } from '../../core'; 

const connector = connect(
    (state: ApplicationState) => ({
        anagrafica: state.core.anagrafiche.anagrafica!,
        logo: state.core.auth.user!.profile.picture!,
        tenantName: state.core.auth.user!.profile.tenantName,
        moduli: state.core.moduli,
        allowCambioAnagrafica: state.core.anagrafiche.lista.length > 1
    }),
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type HomeProps = PropsFromRedux

class Home extends React.Component<HomeProps> {

    render() {
        const { logo, tenantName } = this.props;
        return (
            <Grid centered stackable>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="tablet">
                        <Grid.Row>
                            <Image src={logo} alt={tenantName} size='small' />
                        </Grid.Row>
                    </Media>
                    <Grid.Row>
                        <Grid.Column textAlign='center'>
                            <Header as='h2'>
                                <Header.Content>
                                    {strings.core.home}
                                </Header.Content>
                                <Header.Subheader>
                                    {this.props.anagrafica.ragioneSociale}
                                </Header.Subheader>
                            </Header>
                        </Grid.Column>
                    </Grid.Row>
                    {this.props.allowCambioAnagrafica && this.renderCambioAnagrafica()}
                    <Grid.Row>
                        <Grid.Column widescreen='10' computer='14' tablet='15' mobile='16'>                        
                            {this.props.moduli.chiamate && this.renderChiamate()}
                            {this.props.moduli.ordini && this.renderOrdini()}
                            {this.props.moduli.archiviazione && this.renderArchiviazione()}
                        </Grid.Column>
                    </Grid.Row>
                </MediaContextProvider>
            </Grid>
        );
    }

    renderCambioAnagrafica = () => (
        <Grid.Row>
            <Button basic primary onClick={this.props.cambiaAnagrafica}>
                <Icon name='building outline' />
                {strings.core.header.cambioDitta}
                <Icon name='arrow right' />
            </Button>
        </Grid.Row>
    )

    renderChiamate = () => (
        <>        
            <Divider horizontal>
                {strings.chiamate.modulo}
            </Divider>
            <Grid stackable centered>
                <Grid.Row columns='3' stretched>
                    {this.props.anagrafica.hardware &&
                        <Grid.Column as={Link} to={routes.core.main + routes.chiamate.hardware}>
                            <AzionePrincipale 
                                titolo={strings.chiamate.hardware.titolo}
                                descrizione={strings.chiamate.hardware.descrizione}
                                icon='print'
                                isMobile={window.innerWidth < constants.mediaBreakpoints.tablet}
                            />
                        </Grid.Column>}
                    {this.props.anagrafica.software &&
                        <Grid.Column as={Link} to={routes.core.main + routes.chiamate.software}>
                            <AzionePrincipale 
                                titolo={strings.chiamate.software.titolo}
                                descrizione={strings.chiamate.software.descrizione}
                                icon='computer'
                                isMobile={window.innerWidth < constants.mediaBreakpoints.tablet}
                            />
                        </Grid.Column>}
                    <Grid.Column as={Link} to={routes.core.main + routes.chiamate.elenco}>
                        <AzionePrincipale 
                            titolo={strings.chiamate.elenco.titolo}
                            descrizione={strings.chiamate.elenco.descrizione}
                            icon='list'
                            isMobile={window.innerWidth < constants.mediaBreakpoints.tablet}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    )

    renderOrdini = () => (
        <>
            <Divider horizontal>
                {strings.ordini.modulo}
            </Divider>
            <Grid stackable centered>
                <Grid.Row columns='3' stretched>
                    <Grid.Column as={Link} to={routes.core.main + routes.ordini.materiale}>
                        <AzionePrincipale 
                            titolo={strings.ordini.materiale.titolo}
                            descrizione={strings.ordini.materiale.descrizione}
                            icon='zip'
                            isMobile={window.innerWidth < constants.mediaBreakpoints.tablet}
                        />
                    </Grid.Column>
                    <Grid.Column as={Link} to={routes.core.main + routes.ordini.elenco}>
                        <AzionePrincipale 
                            titolo={strings.ordini.elenco.titolo}
                            descrizione={strings.ordini.elenco.descrizione}
                            icon='list'
                            isMobile={window.innerWidth < constants.mediaBreakpoints.tablet}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    )    

    renderArchiviazione = () => (
        <>
            <Divider horizontal>
                {strings.archivi.modulo}
            </Divider>
            <Grid stackable centered>
                <Grid.Row columns='3' stretched>
                    <Grid.Column as={Link} to={routes.core.main + routes.archivi.archivi}>
                        <AzionePrincipale 
                            titolo={strings.archivi.archivi.titolo}
                            descrizione={strings.archivi.archivi.descrizione}
                            icon='copy outline'
                            isMobile={window.innerWidth < constants.mediaBreakpoints.tablet}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    )
}

export default connector(Home);